import { AuthModule } from '@auth0/auth0-angular';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { CONTAINERS } from './containers';
import { COMPONENTS } from './components';
import { DIRECTIVES } from './directives';

import * as fromReducers from './reducers';
import * as fromEffects from './effects';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng5SliderModule } from 'ng5-slider';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { GalleryModule } from  'ng-gallery';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { AuthFlowComponent } from './components/auth-flow/auth-flow.component';
import { CompanyInfoComponent } from './components/company-info/company-info.component';


@NgModule({
  declarations: [
    AppComponent,
    AuthFlowComponent,
    ...COMPONENTS,
    ...CONTAINERS,
    ...DIRECTIVES,
    CompanyInfoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    FormsModule,
    HttpClientModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    GalleryModule,
    PinchZoomModule,
    Ng5SliderModule,
    InfiniteScrollModule,
    NgxImageZoomModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(fromReducers.reducerMap),
    EffectsModule.forRoot(fromEffects.EFFECTS),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    AuthModule.forRoot({
      domain: 'dev-uzb8cymchraw5zdg.eu.auth0.com',
      clientId: 'MF9ti8FQqIWgYnbjDjCGRmOlNPYlIB6j',
      redirectUri: window.location.origin
    })    
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
